import ppeFullLogo from '../ressources/logo-with-text-green.svg';
import React, { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';

const copingOthersRows = [
  {
    strategy: "SCOPE_REPORT_COPING_SOCIAL_SUPPORT",
    explanation: "SCOPE_REPORT_COPING_SOCIAL_SUPPORT_DESC",
    strengths: "SCOPE_REPORT_COPING_SOCIAL_SUPPORT_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_SOCIAL_SUPPORT_LIMITS",
    noteIndex: 6,
  },
  {
    strategy: "SCOPE_REPORT_COPING_EMPATHY_SEEKING",
    explanation: "SCOPE_REPORT_COPING_EMPATHY_SEEKING_DESC",
    strengths: "SCOPE_REPORT_COPING_EMPATHY_SEEKING_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_EMPATHY_SEEKING_LIMITS",
    noteIndex: 3,
  },
  {
    strategy: "SCOPE_REPORT_COPING_EMOTION_SUPPRESSION",
    explanation: "SCOPE_REPORT_COPING_EMOTION_SUPPRESSION_DESC",
    strengths: "SCOPE_REPORT_COPING_EMOTION_SUPPRESSION_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_EMOTION_SUPPRESSION_LIMITS",
    noteIndex: 2,
  },
];

export default function EditCopingDefinitionsPages2({
  graph,
  code,
  datePassed,
  keyPage,
  getThirdPosition,
  SafeFormattedMessage
}) {

  console.log("EditCopingDefinitionsPages2 props:", graph, code, datePassed, keyPage);
    const languageCtx = useContext(LanguageContext);
    const locale = (languageCtx && languageCtx.locale) ? languageCtx.locale : (graph.language ? graph.language : '');
    const hasLocale = typeof locale === 'string';
    const isGermanLocale = hasLocale && locale.toLowerCase().startsWith('de');
    const isFrenchLocale = hasLocale && locale.toLowerCase().startsWith('fr');
    const footerPageNumber = hasLocale ? (isGermanLocale || isFrenchLocale ? keyPage + 3 : keyPage + 2) : null;
    const copingDefinitionsPagePart = hasLocale ? (isGermanLocale || isFrenchLocale ? 3 : 2) : 2;
  return (
    <div className="PageCharts-chart">
      <div className="header-logo-box">
        <img alt="ppe-logo" className="header-logo-img" src={ppeFullLogo} />
      </div>
      <div className="report-alt-page">
        <h1>
          <SafeFormattedMessage msgKey={graph.title} />
          <span className="inline font-16">
            {" "}
            -{" "}
            <SafeFormattedMessage msgKey="DEFINITIONS" />
          </span>{" "}
          {copingDefinitionsPagePart}
        </h1>
        <span className="coping-sub-title">
          <b>
            <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_OTHERS_TITLE" />
          </b>
        </span>
        <br />
        <table className="coping-table-fullwidth-less">
          <thead>
            <tr className="coping-table-header">
              <th>
                <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_STRATEGY" />
              </th>
              <th className="th-2">
                <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_EXPLANATION" />
              </th>
              <th className="th-3">
                <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_STRENGTHS" />
              </th>
              <th className="th-4">
                <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_LIMITS" />
              </th>
              <th className="th-7">
                <SafeFormattedMessage msgKey="SCOPE_REPORT_COPING_NOTE" />
              </th>
            </tr>
          </thead>
          <tbody>
            {copingOthersRows.map((row, i) => (
              <tr className="coping-table-row" key={i}>
                <th>
                  <SafeFormattedMessage msgKey={row.strategy} />
                </th>
                <td>
                  <SafeFormattedMessage msgKey={row.explanation} />
                </td>
                <td>
                  <SafeFormattedMessage msgKey={row.strengths} />
                </td>
                <td>
                  <SafeFormattedMessage msgKey={row.limits} />
                </td>
                <td>
                  <SafeFormattedMessage
                    msgKey={getThirdPosition ? getThirdPosition(graph.data[row.noteIndex]) : ""}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pdf-footer">
        <SafeFormattedMessage msgKey="PAGE" />{" "}
        {footerPageNumber !== null && <span>{footerPageNumber}</span>}
        <div className="pdf-footer-separator">
          <b>
            <SafeFormattedMessage msgKey="CANDIDATE" />
          </b>
        </div>{" "}
        {code}
        <div className="pdf-footer-separator">
          <b>
            <SafeFormattedMessage msgKey="TEST_DATE" />
          </b>{" "}
          {datePassed}
        </div>
      </div>
    </div>
  );
}